const styles = theme => ({
  portrait: {},
  landscape: {},
  videoControlled: {},
  isFullscreen: {
    backgroundColor: 'white',
    position: ['fixed', '!important'],
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '999',
    '& $eventImage': {
      paddingTop: 0,
      height: '100vh'
    },
    '& $videoWrapper': {
      paddingTop: 0,
      height: '100vh'
    },
    '& $video': {
      left: '50%',
      top: '50%',
      height: '100%',
      width: '177.77777778vh',
      minWidth: '100%',
      minHeight: '56.25vw',
      transform: 'translate(-50%, -50%)'
    }
  },
  videoContainer: {
    position: 'relative',
    overflow: 'hidden',
    height: '100%',
    '&$portrait': {
      '@media (max-width: 767px)': {
        '& $videoWrapper, & $eventImage': {
          transition: theme.transitions.create(
            ['padding-top', 'opacity', 'background-image'],
            {
              duration: theme.transitions.duration.standard,
              easing: theme.transitions.easing.easeInOut
            }
          )
        }
      },
      '&:not($videoControlled)': {
        '@media (max-width: 767px)': {
          '& $videoWrapper, & $eventImage': {
            paddingTop: 'calc(56.25% + 240px)'
          }
        }
      }
    },
    '&:not($videoControlled)': {
      '& $eventImage': {
        backgroundPosition: '50% -60px'
      }
    }
  },
  videoCover: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1
  },
  hide: {
    display: 'none'
  },
  eventImage: {
    width: '100%',
    paddingTop: '56.25%',
    zIndex: 1,
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundBlendMode: 'multiply',
    backgroundColor: 'rgba(40,70,94,.7)',
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut
    })
  },
  eventImageVisible: {
    opacity: 1
  },
  itemImage: {
    backgroundColor: 'transparent',
    transition: `${theme.transitions.create('background-image', {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut
    })} ${theme.transitions.create('opacity', {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
      delay: '0s'
    })}`
  },
  itemImageVisible: {
    opacity: 1,
    backgroundColor: 'rgba(40,70,94,.7)',
    transition: `${theme.transitions.create('background-image', {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut
    })} ${theme.transitions.create('opacity', {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
      delay: '1s'
    })}`
  },
  videoWrapper: {
    width: '100%',
    paddingTop: '56.25%',
    position: 'relative'
  },
  video: {
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0
  },
  engagementBox: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 2
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/LiveVideo/styles.js